import React from 'react';
import { useSelector } from 'react-redux';
import Modal from '../components/Modal';
import Input from '../components/Input';
import Spinner from '../components/Spinner';

export default function AddSenderModal({
  open,
  onConfirm,
  onCancel,
  unassignedLoading,
  unassignedSenderOptions,
  selectedSenderId,
  onSelectSender,
  selectedSenderData,
}) {
  // Resolve the connector type for the selected sender
  const connectors = useSelector(s => s.globalData.connectors) || [];
  const connectorType = selectedSenderData?.vendorAccountId
    ? connectors.find(c => c.vendorAccountId === selectedSenderData.vendorAccountId)?.connectorType
    : null;

  return (
    <Modal
      open={open}
      title="Add a sender"
      ctaButtonText="Add"
      cancelButtonText="Cancel"
      onConfirm={onConfirm}
      onCancel={onCancel}
    >
      <div className="rounded-lg bg-gray-50 shadow-sm outline outline-1 outline-gray-900/5 dark:bg-gray-800/50 dark:shadow-none dark:-outline-offset-1 dark:outline-white/10">
        <dl className="flex flex-wrap">
          <div className={`flex-auto px-6 pt-6 ${selectedSenderData === null ? 'pb-6' : ''}`}>
            {unassignedLoading ? (
              <div className="flex items-center justify-center py-4">
                <Spinner />
              </div>
            ) : unassignedSenderOptions.length === 0 ? (
              <p className="text-sm text-gray-500 dark:text-gray-400 py-2">
                No unassigned senders available. All senders have already been assigned to a template.
              </p>
            ) : (
              <Input
                as="combobox"
                required
                label="Select a sender"
                placeholder="Select a sender"
                options={unassignedSenderOptions}
                value={selectedSenderId}
                onChange={(e) => onSelectSender(e.target.value)}
              />
            )}
          </div>

          {selectedSenderData !== null && (
            <>
              <div className="mt-6 flex w-full flex-none gap-x-4 border-t border-gray-900/5 px-6 pt-6 dark:border-white/10">
                <dt className="flex-none">
                  <p className="text-gray-400 dark:text-gray-500">Sender name</p>
                </dt>
                <dd className="text-sm/6 font-medium text-gray-900 dark:text-white">
                  {selectedSenderData.name}
                </dd>
              </div>
              <div className="mt-4 flex w-full flex-none gap-x-4 px-6">
                <dt className="flex-none">
                  <p className="text-gray-400 dark:text-gray-500">Phone number</p>
                </dt>
                <dd className="text-sm/6 text-gray-500 dark:text-gray-400">
                  {selectedSenderData.number}
                </dd>
              </div>
              <div className="mt-4 flex w-full flex-none gap-x-4 px-6">
                <dt className="flex-none">
                  <p className="text-gray-400 dark:text-gray-500">Sender type</p>
                </dt>
                <dd className="text-sm/6 text-gray-500 dark:text-gray-400">
                  {selectedSenderData.type}
                </dd>
              </div>
              <div className="mt-4 flex w-full flex-none gap-x-4 px-6 mb-6">
                <dt className="flex-none">
                  <p className="text-gray-400 dark:text-gray-500">Connector type</p>
                </dt>
                <dd className="text-sm/6 text-gray-500 dark:text-gray-400">
                  {connectorType ? (
                    <span className="inline-flex items-center rounded-md bg-indigo-50 dark:bg-indigo-900/40 px-2 py-0.5 text-xs font-medium text-indigo-700 dark:text-indigo-300 ring-1 ring-inset ring-indigo-700/10 dark:ring-indigo-400/30">
                      {connectorType}
                    </span>
                  ) : (
                    <span className="text-gray-400">—</span>
                  )}
                </dd>
              </div>
            </>
          )}
        </dl>
      </div>
    </Modal>
  );
}
